import { useTranslation } from 'react-i18next';
import { DoughnutChart } from 'src/common/components/Graphs/common/Graphs/DoughnutChart';
import { useTariffSummarySubscriptionStatusData } from './hooks/useTariffSummarySubscriptionStatusData';

type SubscriptionStatusChartProps = {
  accountRef: string;
  tariffCode: string | null;
};
export const SubscriptionStatusChart = ({
  accountRef,
  tariffCode,
}: SubscriptionStatusChartProps) => {
  const { t } = useTranslation();
  const { chartData, total } = useTariffSummarySubscriptionStatusData({ accountRef, tariffCode });

  return (
    <DoughnutChart
      data={chartData}
      total={total}
      aria-label={t('dashboard.subscriptionsStatusChart.title')}
    />
  );
};
